import { Injectable } from '@angular/core';
import { Uf } from '../interfaces/uf';
import { Municipio } from '../interfaces/municipio';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalidadesService {

  uf: [Uf];
  municiopio: [Municipio];

  private ufEndSource = new Subject<void>();
  private municipioEndSource = new Subject<void>();

  public ufEnd$ = this.ufEndSource.asObservable();
  public municipioEnd$ = this.municipioEndSource.asObservable();


  constructor(
    private http: HttpClient
  ) {

    this.loadAllUf();
    this.loadAllMunicipios();

   }

  loadAllUf() {
    this.http.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados`)
    .subscribe(
      (data) => {
        const myData: any = data;
        this.uf = myData;
        this.ufEndSource.next();
      }
    );
  }

  getAllUf():[Uf] {
    return this.uf;
  }

  loadAllMunicipios() {
    this.http.get(`https://servicodados.ibge.gov.br/api/v1/localidades/municipios`)
    .subscribe(
      (data) => {
        const myData: any = data;
        this.municiopio = myData;
        this.municipioEndSource.next();
      }
    );
  }

  getAllMunicipios() {
    return this.municiopio;
  }

  searchCep(filtroCep: number) {
    if (filtroCep && filtroCep > 0) {
      return this.http.get(`https://viacep.com.br/ws/${filtroCep}/json/`);
    }
  }

  searchRua(uf: string, cidade: string, rua: string): any {
      return this.http.get(`https://viacep.com.br/ws/${uf}/${cidade}/${rua}/json/`, 
      {headers: {
        'Access-Control-Allow-Origin':'*'
      }});
  }

}
